import { useMemo } from 'react';
import { type Page } from '#shared/api/schema';
import { getConstructorPagesSettings, useConstructorPagesSettings } from '../model/slices';

const getChildrenCount = (pages: { [key: string]: Page }, sectionId?: string) => {
    if (!sectionId) {
        return 0;
    }

    let count = 0;

    Object.values(pages).forEach((page: Page) => {
        page.layout.forEach((section) => {
            if (section.id === sectionId && section.section_type === 'child') {
                count++;
            }
        });
    });

    return count;
};

const getPagesWithChildren = (pages: { [key: string]: Page }, sectionId?: string) => {
    if (!sectionId) {
        return [];
    }

    return Object.values(pages).filter((page: Page) =>
        page.layout.some((section) => section.id === sectionId && section.section_type === 'child')
    );
};

export function useConstructorCountChildren({ sectionId }: { sectionId?: string }): {
    childrenCount: number;
    pagesWithChildren: Page[];
} {
    const pages = useConstructorPagesSettings();

    const childrenCount = useMemo(() => getChildrenCount(pages, sectionId), [pages, sectionId]);

    const pagesWithChildren = useMemo(() => getPagesWithChildren(pages, sectionId), [pages, sectionId]);

    return {
        childrenCount,
        pagesWithChildren,
    };
}

export const getConstructorCountChildren = ({ sectionId }: { sectionId?: string }) => {
    const pages = getConstructorPagesSettings();

    const childrenCount = getChildrenCount(pages, sectionId);

    const pagesWithChildren = Object.values(pages).filter((page: Page) =>
        page.layout.some((section) => section.id === sectionId && section.section_type === 'child')
    );

    return {
        childrenCount,
        pagesWithChildren,
    };
};
